module.exports = __webpack_public_path__ + "static/grow.9070b8f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/index/assets/grow.jpg
// module id = 368
// module chunks = 35783957827783